import settings from '../../../config/settings';
import axios from '../api/axios';
import humps from 'humps';
import qs from 'qs';
import _ from 'lodash';

export default class UserApi {
  static getUser(id) {
    return axios.get(`${settings.apiBaseURL}/users/${id}`);
  }

  static getUsers(query) {
    const q = humps.decamelizeKeys(_.omitBy(query, p => !p));

    return axios.get(`${settings.apiBaseURL}/users?${qs.stringify(q)}`);
  }
}



// WEBPACK FOOTER //
// ./shared/publicUser/api.js